module.exports = __webpack_public_path__ + "static/media/img-function-offer@3x.839d092a.png";